import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ContextoGeral } from "../contextos/ContextoGeral"
import ProfissionalAPI from "../servicos/ProfissionalAPI"
import {
	carregarGoogleMapsSdk,
	mapaGoogleRecusado,
	registrarUsoMapaProfissional
} from "../servicos/googleMapsProfissional"

function centroValido(center) {
	if (!Array.isArray(center) || center.length < 2) return false
	const lat = Number(center[0])
	const lng = Number(center[1])
	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false
	if (lat === 0 && lng === 0) return false
	if (lat === -14.24 && lng === -51.925) return false
	return true
}

export default function MapaGoogle({ chave, dominio, center, zoom, enderecos, onFalhar, children }) {
	const navegar = useNavigate()
	const { dados } = useContext(ContextoGeral)
	const elRef = useRef(null)
	const mapRef = useRef(null)
	const infoRef = useRef(null)
	const marcadoresRef = useRef([])
	const voceRef = useRef(null)
	const inicialRef = useRef(true)
	const vivoRef = useRef(true)
	const [pronto, setPronto] = useState(false)

	useEffect(() => {
		vivoRef.current = true
		let relogioFalha = 0
		let relogioUso = 0
		const falhaAnterior = window.gm_authFailure
		const desistir = () => {
			if (!vivoRef.current) return
			vivoRef.current = false
			onFalhar?.()
		}
		window.gm_authFailure = () => {
			desistir()
			if (typeof falhaAnterior === "function") falhaAnterior()
		}
		carregarGoogleMapsSdk(chave).then((ok) => {
			if (!vivoRef.current) return
			const g = window.google
			if (!ok || !g?.maps || !elRef.current) {
				desistir()
				return
			}
			const inicio = centroValido(center)
				? { lat: Number(center[0]), lng: Number(center[1]) }
				: { lat: -14.2400732, lng: -53.180501 }
			const map = new g.maps.Map(elRef.current, {
				center: inicio,
				zoom: Number(zoom) || 16,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				zoomControl: false,
				clickableIcons: false
			})
			mapRef.current = map
			infoRef.current = new g.maps.InfoWindow()
			setPronto(true)
			relogioFalha = window.setInterval(() => {
				if (mapaGoogleRecusado(elRef.current)) desistir()
			}, 400)
			relogioUso = window.setTimeout(() => {
				window.clearInterval(relogioFalha)
				if (!vivoRef.current || mapaGoogleRecusado(elRef.current)) {
					if (vivoRef.current) desistir()
					return
				}
				registrarUsoMapaProfissional(dominio)
			}, 8000)
		})
		return () => {
			vivoRef.current = false
			window.clearInterval(relogioFalha)
			window.clearTimeout(relogioUso)
			if (window.gm_authFailure !== falhaAnterior) window.gm_authFailure = falhaAnterior
			marcadoresRef.current.forEach((m) => m.setMap(null))
			marcadoresRef.current = []
			voceRef.current?.setMap(null)
			voceRef.current = null
			mapRef.current = null
			setPronto(false)
		}
	}, [chave, dominio])

	useEffect(() => {
		const map = mapRef.current
		if (!map || !centroValido(center)) return
		const destino = { lat: Number(center[0]), lng: Number(center[1]) }
		if (inicialRef.current) {
			map.setCenter(destino)
			map.setZoom(16)
			inicialRef.current = false
			return
		}
		const atual = map.getCenter()
		let proximoZoom = 16
		if (atual) {
			const mesmo = atual.lat().toFixed(3) === destino.lat.toFixed(3)
				&& atual.lng().toFixed(3) === destino.lng.toFixed(3)
			if (mesmo) proximoZoom = map.getZoom() === 12 ? 16 : 12
		}
		map.panTo(destino)
		map.setZoom(proximoZoom)
	}, [center, pronto])

	useEffect(() => {
		const map = mapRef.current
		const g = window.google
		if (!map || !g?.maps) return undefined
		marcadoresRef.current.forEach((m) => m.setMap(null))
		marcadoresRef.current = []
		const lista = Array.isArray(enderecos) ? enderecos : []
		lista.forEach((endereco) => {
			const lat = Number(endereco?.la)
			const lng = Number(endereco?.lo)
			if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
			const marcador = new g.maps.Marker({
				map,
				position: { lat, lng },
				title: String(endereco.idServico || ""),
				icon: {
					path: g.maps.SymbolPath.CIRCLE,
					scale: 10,
					fillColor: endereco.cor || "#6d4c41",
					fillOpacity: 1,
					strokeColor: "#111",
					strokeWeight: 1
				}
			})
			marcador.addListener("click", () => {
				const caixa = document.createElement("div")
				caixa.style.maxWidth = "50vw"
				const titulo = document.createElement("div")
				titulo.style.fontWeight = "500"
				titulo.textContent = String(endereco.idServico || "")
				const texto = document.createElement("div")
				texto.textContent = String(endereco.end || "")
				const acoes = document.createElement("div")
				acoes.style.display = "flex"
				acoes.style.gap = "0.5rem"
				acoes.style.marginTop = "0.4rem"
				const gps = document.createElement("button")
				gps.type = "button"
				gps.className = "w-50 small"
				gps.textContent = "GPS"
				gps.onclick = () => {
					if (window.AndroidInterface && typeof window.AndroidInterface.abrirMaps === "function")
						window.AndroidInterface.abrirMaps(`${endereco.la}, ${endereco.lo}`)
					else alert("não está no android")
				}
				const ver = document.createElement("button")
				ver.type = "button"
				ver.className = "w-50 small"
				ver.textContent = "Ver Ponto"
				ver.onclick = () => navegar("/app/servicos/" + endereco.idServico)
				acoes.append(gps, ver)
				caixa.append(titulo, texto, acoes)
				infoRef.current.setContent(caixa)
				infoRef.current.open({ map, anchor: marcador })
			})
			marcadoresRef.current.push(marcador)
		})
		return undefined
	}, [enderecos, navegar, pronto])

	useEffect(() => {
		let timer = 0
		let ativo = true
		async function ler(enviar) {
			if (!window.AndroidInterface || typeof window.AndroidInterface.getLocation !== "function") return
			try {
				const localizacao = JSON.parse(await window.AndroidInterface.getLocation())
				const lat = Number(localizacao?.latitude)
				const lng = Number(localizacao?.longitude)
				if (!ativo || !Number.isFinite(lat) || !Number.isFinite(lng) || lat === 0 || lng === 0) return
				const g = window.google
				const map = mapRef.current
				if (!g?.maps || !map) return
				if (!voceRef.current) {
					voceRef.current = new g.maps.Marker({
						map,
						position: { lat, lng },
						title: "Você está aqui!",
						zIndex: 999
					})
				} else {
					voceRef.current.setPosition({ lat, lng })
					voceRef.current.setMap(map)
				}
				if (enviar && dados?.statusOnline) {
					ProfissionalAPI.enviarLocalizacao(dados, {
						idProf: dados.idProf,
						la: lat,
						lo: lng
					})
				}
			} catch { /* a posição segue no próximo ciclo */ }
		}
		if (dados?.statusOnline) {
			ler(true)
			timer = window.setInterval(() => ler(false), 5000)
		} else {
			voceRef.current?.setMap(null)
		}
		return () => {
			ativo = false
			window.clearInterval(timer)
		}
	}, [dados, pronto])

	return <>
		<div ref={elRef} style={{ height: "var(--app-vh)", width: "100vw", overflow: "hidden" }} />
		{children}
	</>
}
